// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2bsRe","left":"InfoRow_left__qJ70k"};